import { useEffect } from 'react';
// @mui
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// routes
import { usePathname } from 'src/routes/hook';
// components
import Logo from 'src/components/logo';
import SvgColor from 'src/components/svg-color';
import Scrollbar from 'src/components/scrollbar';
//
import { Box } from '@mui/material';
import NavList from './nav-list';

// ----------------------------------------------------------------------

export default function NavMobile({ offsetTop, data }: any) {
  const pathname = usePathname();

  const nav = useBoolean();

  // Force dark theme for mobile menu but KEEP app typography and settings
  const appTheme = useTheme();
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
    typography: {
      ...appTheme.typography,
    },
  });

  useEffect(() => {
    if (nav.value) {
      nav.onFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <IconButton
        onClick={nav.onTrue}
        sx={{
          ml: 1,
          ...(offsetTop && {
            color: 'text.primary',
          }),
        }}
      >
        <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
      </IconButton>

      <ThemeProvider theme={darkTheme}>
        <Drawer
          open={nav.value}
          onClose={nav.onFalse}
          PaperProps={{
            sx: {
              pb: 5,
              width: 260,
              bgcolor: '#333333',
              color: '#fefefe',
              backgroundImage: 'none',
              '& .MuiScrollbar-root': {
                bgcolor: 'transparent',
              },
              '& .MuiList-root': {
                bgcolor: 'transparent',
              },
            },
          }}
        >
          <Scrollbar sx={{ bgcolor: 'transparent', '& > *': { bgcolor: 'transparent' } }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2, bgcolor: 'transparent' }}>
              <Logo sx={{ mx: 2.5, my: 3 }} />
            </Box>

            <List component="nav" disablePadding sx={{ bgcolor: 'transparent' }}>
              {data.map((link: any) => (
                <NavList key={link.title} item={link} />
              ))}
            </List>
          </Scrollbar>
        </Drawer>
      </ThemeProvider>
    </>
  );
}
